import { getScriptOrLoad } from '../ScriptLoader/ScriptLoader';
import {
  Address,
  Geocode,
  GoogleMapsSdk,
  PlacesServiceStatusTypes,
} from './types';

const locationFuncOrValue = (locationProp: () => any) => {
  return typeof locationProp === 'function' ? locationProp() : locationProp;
};

const serializeResult = (results: any) => ({
  ...results,
  geometry: {
    ...results.geometry,
    location: {
      lat: locationFuncOrValue(results.geometry.location.lat),
      lng: locationFuncOrValue(results.geometry.location.lng),
    },
  },
});

const loadScript = (clientId: any, lang: any) => {
  return getScriptOrLoad('googleMaps', {
    language: lang,
    apiKey: clientId,
  });
};

export const autocomplete = async (
  clientId: string,
  lang: string,
  request: any,
): Promise<Array<Address>> => {
  const promise = new Promise(async (resolve, reject) => {
    const googleMapsSdk: GoogleMapsSdk = await loadScript(clientId, lang);
    googleMapsSdk.autocomplete.getPlacePredictions(
      typeof request === 'string' ? { input: request } : request,
      (results: any, status: any) => {
        if (status === PlacesServiceStatusTypes.Ok) {
          resolve(results);
        } else {
          reject(status);
        }
      },
    );
  });

  return promise as Promise<Array<Address>>;
};

export const geocode = async (
  clientId: string,
  lang: string,
  request: any,
): Promise<Array<Geocode>> => {
  const promise = new Promise(async (resolve, reject) => {
    const googleMapsSdk: GoogleMapsSdk = await loadScript(clientId, lang);
    googleMapsSdk.geocode.geocode(
      typeof request === 'string' ? { address: request } : request,
      (results: any, status: any) => {
        if (status === PlacesServiceStatusTypes.Ok) {
          resolve(results.map((result: any) => serializeResult(result)));
        } else {
          reject(status);
        }
      },
    );
  });
  return promise as Promise<Array<Geocode>>;
};
